import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { linkTypeEnum } from 'src/app/models/enums';
import { menu } from 'src/app/models/menu';
import { rootModel } from 'src/app/models/rootModel';
import { DataService } from 'src/app/Services/data.service';
import { TranslateService } from 'src/app/Services/translate.service';

@Component({
  selector: 'app-home-layout',
  templateUrl: './home-layout.component.html',
  styleUrls: ['./home-layout.component.css']
})
export class HomeLayoutComponent implements OnInit {
  rootModel: rootModel = new rootModel();
  menus: menu[] = [];
  arsivMenu: menu = new menu();

  elinkTypeEnum = linkTypeEnum;
  top: number;
  left: number;

  boschild: menu[] = [];
  constructor(
    public translateService: TranslateService,
    private dataServices: DataService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {

      this.rootModel.language = params.get("language");
      if (!this.rootModel.language) {
        this.rootModel.language = 'tr';
      }
      this.getMenu(this.rootModel);

      //burası sayfa tekrar çağrıldığında, dil default türkçe olduğu için ingilizce sayfalarında türkçe gelmemesi için yazıldı.
      this.translateService.use(this.rootModel.language);

    })
  }

  getMenu(rootModel) {
    this.menus = [];
    this.dataServices.getMenus(rootModel).subscribe(p => {

      this.menus = p;

      // this.menus.push(this.arsivMenu); 
    });

  }

  actifLink(actifMenu:menu):string
  {

    var aktifUrl = this.router.url;
     var categoryId = aktifUrl.split('/')[3];    
 
      if(actifMenu.external_link == categoryId)
          return 'actifLink';
      else        
      return '';


  }
  actifLinkArsiv(): string {
    var aktifUrl = this.router.url;
    var archive = aktifUrl.split('/')[2];

    if ('archive' == archive)
      return 'actifLink';
    else
      return '';

  }
  dilTr(): void {
    //alert(girdi);
    this.rootModel.language = "tr";
    this.translateService.use('tr');
    this.getMenu(this.rootModel);

   
  }

  dilEn(): void {
    this.rootModel.language = "en";
    this.translateService.use('en');
    this.getMenu(this.rootModel);
  }


  strbosluk(str: string) {
    var i: number;
    var bosluk = str.split(' ').length;
    for (i = bosluk; i >= 1; i--) {
      str = str.replace(' ', '-');
    }
    return str;
  }

  isStrDrowdown(menu: menu): String {
    if (menu.children)
      return "drowdown";
    else
      return " ";



  }
}
